import { render } from "./ApiSection.vue?vue&type=template&id=8117e9c0"
import script from "./ApiSection.vue?vue&type=script&lang=js"
export * from "./ApiSection.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__